import moment from "moment";
import {
  ARCHIVE,
  ACTIVITY_GROUPS,
  ACTIVITY_GROUPS2,
  TOTAL,
  KEY_DATE_FORMAT,
  IMWAREHOUSEMETRICS_COLLECTION,
  COUNTRY,
  WORKER_ID,
  DASHBOARD_COLLECTION,
  DSC_DASHBOARD_COLLECTION,
  CAPACITY_PLANNING,
  BUILDINGS_SUBCOLLECTION,
  LOCATIONS_COLLECTION
} from "config/CONSTANTS";
import { createReviewData } from "pages/Review/components/ReviewList/utils";
import { getWorkersByMgr, getWorkerPunches, getWorkerTransportPunches } from "services";
import { getContractorReportData } from "services/contractorTimesheet";
import {
  getDurationInHours,
  isEmptyObject,
  properCamelCaseNew,
} from "utils/index";
import { timeConfig, dateConfig, SET_EMPTY, NO_EXCEPTION } from "config";
import { udpateHighDurationPunchStatus } from "utils/activity";
import {
  EDIT_STATUS,
  NEW_STATUS,
  PENDING_STATUS,
  INCOMPLETE_STATUS,
  EXCEPTION_STATUS,
  INCOMPLETE_BG_INVALID,
  INCOMPLETE_BG_VALID,
  DISTRICT_ID,
  PRIMARY_BUILDING,
  START_DATE
} from "config";
import { MEAL } from "pages/Punch/constants";
import { timesheetsRef, collectionRef, collectionGroup } from "services/firebase";
import {getWeekStartDate} from "services";
/**
 * Fn for fetching the data for activity group report
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the report data
 */
export const getActivityGroupReportData = (managerId, startDate, endDate) => {
  console.log("services > getActivityGroupReportData called...");
  return new Promise((resolve, reject) => {
    try {
      let reportData = [];
      let activityGroupMap = new Map();
      getWorkerPunchRecords(managerId, startDate, endDate, false)
        .then((punches) => {
          punches = punches.punchData;
          if (punches && !isEmptyObject(punches)) {
            const workerIds = Object.keys(punches);
            console.log("Report -> workerIds: ", workerIds);
            if (workerIds.length > 0) {
              for (let i = 0; i < workerIds.length; i++) {
                //console.table(punches[workerIds[i]]);
                const validRecords = createReviewData(punches[workerIds[i]]);
                //console.table(validRecords);
                const activityGroupData = calculateReportData(validRecords);
                const activityGroupList = ACTIVITY_GROUPS;
                if (activityGroupData && !isEmptyObject(activityGroupData)) {
                  for (let k = 0; k < activityGroupList.length; k++) {
                    const activityGroup = activityGroupList[k];
                    if (activityGroupData[activityGroup]) {
                      let hrs;
                      if (activityGroupMap.get(activityGroup)) {
                        hrs =
                          activityGroupMap.get(activityGroup) +
                          activityGroupData[activityGroup];
                      } else {
                        hrs = activityGroupData[activityGroup];
                      }
                      activityGroupMap.set(activityGroup, hrs);
                    }
                  }
                }
              }
            }
            for (let actGrp of activityGroupMap.keys()) {
              const actGrpHours = activityGroupMap.get(actGrp);
              let actGrpData = {
                name: actGrp,
                value: Math.floor(actGrpHours * 100) / 100,
              };
              reportData.push(actGrpData);
            }
          }
          console.log(
            `Report -> Activity Group Data -> ${JSON.stringify(reportData)}`
          );
          resolve(reportData);
        })
        .catch((err) => {
          console.error(
            "in services > getActivityGroupReportData, Err===",
            err
          );
          reject(err);
        });
    } catch (error) {
      console.error("in services > getActivityGroupReportData, Err===", error);
      reject(error);
    }
  });
};

export const getHighDurationWorkerRecords = (workerId, startDate, endDate) => {
  console.log("services > get HighDurationWorker called...", workerId);
  return new Promise((resolve, reject) => {
    try {
      let reportData = {};

      getPunchesReportData(
        workerId,
        moment(startDate).format(dateConfig.format4),
        moment(endDate).format(dateConfig.format4)
      ).then((data) => {
        if (data && data.length > 0) {
          data = udpateHighDurationPunchStatus(data);
          //console.log("services > data update high duration called...",data);
        }
        resolve(data);
      });
    } catch (error) {
      console.error("in services > getActivityGroupReportData, Err===", error);
      reject(error);
    }
  });
};

/**
 * Fn for calculating the activity group report data
 * @param {array} array of punch records
 * @return {object} reportData
 */
export const calculateReportData = (punchEntries) => {
  console.log("utils > calculateReportData called");
  let reportData = {};
  if (punchEntries) {
    punchEntries.map((entry) => {
      if (entry.status != "pgReview.tableStaticText.exception") {
        const validPunches = entry.punches;
        validPunches.map((item) => {
          if (item.status !== ARCHIVE && item.inLocalTS && item.outLocalTS) {
            /*console.log(`utils > ${item.activityGroup} > ${item.inLocalTS.substr(0, 16)}`+
                `> ${item.outLocalTS.substr(0, 16)}`);*/
            const activityGroupName = item.activityGroup;
            const hours = calculateDiffInHrs(item.inLocalTS, item.outLocalTS);
            let diff;
            if (reportData[activityGroupName]) {
              diff = reportData[activityGroupName] + hours;
            } else {
              diff = hours;
            }
            reportData[activityGroupName] = diff;
          }
        });
        console.log("utils > Activity Group Data > ", reportData);
      }
    });
  }
  return reportData;
};

/**
 * Fn to calculate the time difference in hours
 * @param {string} startTS
 * @param {string} endTS
 * @return {number} hoursDiff
 */
export const calculateDiffInHrs = (startTS, endTS) => {
  let hoursDiff = moment(endTS && endTS.substr(0, 16)).diff(
    moment(startTS && startTS.substr(0, 16)),
    "hours",
    true
  );
  return hoursDiff;
};

/**
 * Fn for fetching the data for job family report
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the report data
 */
export const getJobFamilyReportData = (
  managerId,
  startDate,
  endDate,
  filters
) => {
  console.log(",,,,,,,,,,,,,,,,,,,,,,,,,,,,,", filters);
  console.log("services > getJobFamilyReportData called...");
  return new Promise((resolve, reject) => {
    try {
      let reportData = {};
      let jobFamilyReportData = [];
      getWorkerPunchRecords(managerId, startDate, endDate, false)
        .then((punches) => {
          punches = punches.punchData;
          if (punches && !isEmptyObject(punches)) {
            let workerIds = Object.keys(punches);
            if (workerIds.length > 0) {
              for (let i = 0; i < workerIds.length; i++) {
                //console.table(punches[workerIds[i]]);
                const validRecords = createReviewData(punches[workerIds[i]]);
                //console.table(validRecords);
                const jobFamilyData = calculateJobFamilyReportData(
                  validRecords,
                  filters
                );
                if (jobFamilyData && !isEmptyObject(jobFamilyData)) {
                  const jobFamilies = Object.keys(jobFamilyData);
                  for (let k = 0; k < jobFamilies.length; k++) {
                    const jobFamilyName = jobFamilies[k];
                    if (jobFamilyData[jobFamilyName]) {
                      for (let type of Object.keys(
                        jobFamilyData[jobFamilyName]
                      )) {
                        //type can be total/Transactional/Non-Transactional/Project
                        let data = {};
                        let totalHrs = jobFamilyData[jobFamilyName][type];
                        if (reportData[jobFamilyName]) {
                          data = reportData[jobFamilyName];
                          if (data[type]) {
                            totalHrs = data[type] + totalHrs;
                          }
                        }
                        data[type] = Math.round(totalHrs * 100) / 100;
                        reportData[jobFamilyName] = data;
                      }
                    }
                  }
                }
              }
              for (let jobFamily of Object.keys(reportData)) {
                let data = {};
                data = reportData[jobFamily];
                data.Name = jobFamily;
                jobFamilyReportData.push(data);
              }
            }
          }
          console.log(
            `Report -> Job Family Data -> ${JSON.stringify(
              jobFamilyReportData
            )}`
          );
          resolve(jobFamilyReportData);
        })
        .catch((err) => {
          console.error("in services > getJobFamilyReportData, Err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getJobFamilyReportData, Err===", error);
      reject(error);
    }
  });
};

export const getWorkersListByMgr = (managerId) => {
  console.log("services > getWorkersIdNameByMgr called...");

  return new Promise((resolve, reject) => {
    try {
      const document = [];
      getWorkersByMgr(managerId)
        .then((data) => {
          const workerIds = data.workerIds;
          const workerDetails = data.workers;

          workerIds.forEach((workerId, index) => {
            const workerName =
              workerDetails[index].firstName +
              " " +
              workerDetails[index].lastName;

            document.push({ workerId: workerId, workerName: workerName });
          });

          resolve(document);
        })
        .catch((err) => {
          console.error("in services > getJobFamilyReportData, err===" + err);

          reject(err);
        });
    } catch (error) {
      console.error("in services > getJobFamilyReportData, Err===", error);

      reject(error);
    }
  });
};

/**
 * Fn for fetching timesheet data for worker
 * @param {string} - workerId
 * @param {number} - weekNumber
 * @return: Promise - return the report data
 */
export const getEmployeeWeekData = (workerId, weekNumber) => {
  console.log("services > getEmployeeWeekData called...");
  const documentName = weekNumber + "-" + workerId;

  return new Promise((resolve, reject) => {
    try {
      let data = {};
      timesheetsRef()
        .doc(documentName)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.data()) {
            data = querySnapshot.data();
          }

          resolve(data);
        })
        .catch((err) => {
          console.error("in services > getEmployeeWeekData, err===" + err);

          reject(err);
        });
    } catch (error) {
      console.error("in services > getEmployeeWeekData, Err===", error);

      reject(error);
    }
  });
};

/**
 * Fn for calculating the job family report data
 * @param {array} array of punch records
 * @return {object} reportData
 */

const getFilters = (item, filters) => {
  let defaultFilter;
  switch (filters) {
    case "Show Meal":
      defaultFilter =
        item.status !== ARCHIVE &&
        item.inLocalTS &&
        item.outLocalTS &&
        item.activityGroup != "Leave";
      break;
    default:
      defaultFilter =
        item.status !== ARCHIVE &&
        item.inLocalTS &&
        item.outLocalTS &&
        item.activityGroup != "Meal" &&
        item.activityGroup != "Leave";
  }
  return defaultFilter;
};

export const calculateJobFamilyReportData = (punchEntries, filters) => {
  let reportData = {};
  if (punchEntries) {
    //console.log("utils > Calculating hours for ",punchEntries[0].worker);
    punchEntries.map((entry) => {
      if (entry.status != "pgReview.tableStaticText.exception") {
        const validPunches = entry.punches;
        validPunches.map((item) => {
          console.log("activityGroup", item.activityGroup);
          let setFilter = getFilters(item, filters);
          if (setFilter) {
            /* console.log(`utils > ${item.jobName} -> ${item.activityGroup} `+
    `${item.inLocalTS.substr(0, 16)} -> ${item.outLocalTS.substr(0, 16)}`);*/
            const jobName = item.jobName;
            const agName = item.activityGroup;
            const hours = calculateDiffInHrs(item.inLocalTS, item.outLocalTS);
            let diff;
            if (!reportData[jobName]) {
              reportData[jobName] = {};
            }
            if (reportData[jobName][TOTAL]) {
              diff = reportData[jobName][TOTAL] + hours;
            } else {
              diff = hours;
            }
            reportData[jobName][TOTAL] = diff;

            if (reportData[jobName][agName]) {
              diff = reportData[jobName][agName] + hours;
            } else {
              diff = hours;
            }
            reportData[jobName][agName] = diff;
          }
        });
        console.log("@@@@", reportData);
      }
    });
  }
  return reportData;
};

/**
 * Fn for fetching the data for punches tabular report data
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the report data
 */
export const getPunchesReportData = (managerId, startDate, endDate) => {
  console.log("utils > getPunchesReportData called...");
  return new Promise((resolve, reject) => {
    try {
      let reportData = [];
      let workerDetails = {};
      const previousStartDate = moment()
        .subtract(2, "weeks")
        .startOf("week")
        .format("YYYY-MM-DD");
      const futureEndDate = moment()
        .add(2, "weeks")
        .startOf("week")
        .format("YYYY-MM-DD");
      getWorkerPunchRecords(managerId, startDate, endDate, true)
        .then((punches) => {
          workerDetails = punches.workers;
          punches = punches.punchData;
          if (punches && !isEmptyObject(punches)) {
            let workerIds = Object.keys(punches);
            console.log("Report -> workerIds: ", workerIds);
            if (workerIds.length > 0) {
              for (let i = 0; i < workerIds.length; i++) {
                let punchesArray = punches[workerIds[i]];
                punchesArray.map((punch) => {
                  punch.worker = workerDetails[workerIds[i]];
                  punch.name =
                    workerDetails[workerIds[i]].firstName +
                    " " +
                    workerDetails[workerIds[i]].lastName;
                  punch.duration = getDurationInHours(punch);
                  punch.startDate = punch.inLocalTS
                    ? date(punch.inLocalTS)
                    : SET_EMPTY;
                  punch.startTime = punch.inLocalTS
                    ? time(punch.inLocalTS)
                    : SET_EMPTY;
                  punch.endDate = punch.outLocalTS
                    ? date(punch.outLocalTS)
                    : SET_EMPTY;
                  punch.endTime = punch.outLocalTS
                    ? time(punch.outLocalTS)
                    : SET_EMPTY;
                  if (punch.exceptionName) {
                    punch.exceptionName = punch.exceptionName.toLowerCase();
                    if (punch.exceptionName === NO_EXCEPTION) {
                      punch.exceptionName = SET_EMPTY;
                    }
                  }
                  punch.editable = true;
                  if (punch.nonEditable && punch.nonEditable === true) {
                    punch.editable = false;
                  }

                  if (punch.inLocalTS) {
                    let punchInRecordDate = moment(punch.inLocalTS).format(
                      "YYYY-MM-DD"
                    );
                    if (
                      moment(punchInRecordDate).isBefore(previousStartDate) ||
                      moment(punchInRecordDate).isAfter(futureEndDate)
                    ) {
                      punch.editable = false;
                    }
                  }

                  if (!punch.outLocalTS) {
                    punch.outLocalTS = "";
                  }
                  if (!punch.inLocalTS) {
                    punch.inLocalTS = "";
                  }
                });
                reportData.push(...punchesArray);
              }
            }
          }
          //console.log(`-> Report Data -> ${JSON.stringify(reportData)}`);
          resolve(reportData);
        })
        .catch((err) => {
          console.error("in utils > getPunchesReportData, Err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in utils > getPunchesReportData, Err===", error);
      reject(error);
    }
  });
};

	/**
 * Fn for fetching the data for punches tabular report data
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the report data
 */
  export const getContractorPunchesReportData = (managerId, startDate, endDate) => {
    console.log("utils > getPunchesReportData called...");
    return new Promise((resolve, reject) => {
      try {
        let reportData = [];
        const previousStartDate = moment()
          .subtract(2, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");
        const futureEndDate = moment()
          .add(2, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");
        getContractorReportData (managerId, startDate, endDate, true )
            .then((punchReports) => {
            if (punchReports && !isEmptyObject(punchReports)) {
              let documentIds = Object.keys(punchReports);
              console.log("Report -> documentIds: ", documentIds);
              if (documentIds.length > 0) {
                for (let i = 0; i < documentIds.length; i++) {
                  const {punches:punchesData, weekTotals, dayTotals, ...workerData} = punchReports[documentIds[i]];
                  let punchesArray = punchesData ? Object.values(punchesData) : [];
                  punchesArray.forEach((punch) => {
                    punch.worker = {...workerData};
                    punch.workerId = workerData.workerId ? workerData.workerId : "";
                    punch.email = workerData.email ? workerData.email : "";
                    punch.managerId = workerData.managerId ? workerData.managerId : "";
                    punch.managerName = workerData.managerName ? workerData.managerName : "";
                    punch.name = punchReports[documentIds[i]]?.name;
                    punch.duration = getDurationInHours(punch);
                    punch.dayTotalDuration = punch.dayName && dayTotals && dayTotals[punch.dayName].hours ? dayTotals[punch.dayName].hours : "";
                    punch.weekTotalDuration = weekTotals && weekTotals.hours ? weekTotals.hours : "";
                    punch.weekNumber = workerData.weekNumber ? workerData.weekNumber : "";
                    punch.startDate = punch.inLocalTS
                      ? date(punch.inLocalTS)
                      : SET_EMPTY;
                    punch.startTime = punch.inLocalTS
                      ? time(punch.inLocalTS)
                      : SET_EMPTY;
                    punch.endDate = punch.outLocalTS
                      ? date(punch.outLocalTS)
                      : SET_EMPTY;
                    punch.endTime = punch.outLocalTS
                      ? time(punch.outLocalTS)
                      : SET_EMPTY;
                    if (punch.exceptionName) {
                      punch.exceptionName = punch.exceptionName.toLowerCase();
                      if (punch.exceptionName === NO_EXCEPTION) {
                        punch.exceptionName = SET_EMPTY;
                      }
                    }
                    punch.editable = true;
                    if (punch.nonEditable && punch.nonEditable === true) {
                      punch.editable = false;
                    }
  
                    if (punch.inLocalTS) {
                      let punchInRecordDate = moment(punch.inLocalTS).format(
                        "YYYY-MM-DD"
                      );
                      if (
                        moment(punchInRecordDate).isBefore(previousStartDate) ||
                        moment(punchInRecordDate).isAfter(futureEndDate)
                      ) {
                        punch.editable = false;
                      }
                    }
  
                    if (!punch.outLocalTS) {
                      punch.outLocalTS = "";
                    }
                    if (!punch.inLocalTS) {
                      punch.inLocalTS = "";
                    }
                  });
                  reportData.push(...punchesArray);
                }
              }
            }
            //console.log(`-> Report Data -> ${JSON.stringify(reportData)}`);
            resolve(reportData);
          })
          .catch((err) => {
            console.error("in utils > getPunchesReportData, Err===", err);
            reject(err);
          });
      } catch (error) {
        console.error("in utils > getPunchesReportData, Err===", error);
        reject(error);
      }
    });
  };

/**
 * Fn for fetching the data for punches tabular report data
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the report data
 */
export const getTransportPunchesData = (managerId, startDate, endDate) => {
  console.log("utils > getTransportPunchesData called...");
  return new Promise((resolve, reject) => {
    try {
      let reportData = [];
      let workerDetails = {};
      const previousStartDate = moment()
        .subtract(2, "weeks")
        .startOf("week")
        .format("YYYY-MM-DD");
      const futureEndDate = moment()
        .add(2, "weeks")
        .startOf("week")
        .format("YYYY-MM-DD");
        getWorkerTransportPunchRecords(managerId, startDate, endDate, true)
        .then((punches) => {
          workerDetails = punches.workers;
          punches = punches.punchData;
          if (punches && !isEmptyObject(punches)) {
            let workerIds = Object.keys(punches);
            console.log("Report -> workerIds: ", workerIds);
            if (workerIds.length > 0) {
              for (let i = 0; i < workerIds.length; i++) {
                let punchesArray = punches[workerIds[i]];
                punchesArray.map((punch) => {
                  punch.worker = workerDetails[workerIds[i]];
                  punch.name =
                    workerDetails[workerIds[i]].firstName +
                    " " +
                    workerDetails[workerIds[i]].lastName;
                  punch.duration = getDurationInHours(punch);
                  punch.startDate = punch.inLocalTS
                    ? date(punch.inLocalTS)
                    : SET_EMPTY;
                  punch.startTime = punch.inLocalTS
                    ? time(punch.inLocalTS)
                    : SET_EMPTY;
                  punch.endDate = punch.outLocalTS
                    ? date(punch.outLocalTS)
                    : SET_EMPTY;
                  punch.endTime = punch.outLocalTS
                    ? time(punch.outLocalTS)
                    : SET_EMPTY;
                  punch.tripStartDate = punch.startTripLocalTS
                    ? date(punch.startTripLocalTS)
                    : SET_EMPTY;
                  punch.tripStartTime = punch.startTripLocalTS
                    ? time(punch.startTripLocalTS)
                    : SET_EMPTY;
                  punch.tripEndDate = punch.endTripLocalTS
                    ? date(punch.endTripLocalTS)
                    : SET_EMPTY;
                  punch.tripEndTime = punch.endTripLocalTS
                    ? time(punch.endTripLocalTS)
                    : SET_EMPTY;  
                  if (punch.exceptionName) {
                    punch.exceptionName = punch.exceptionName.toLowerCase();
                    if (punch.exceptionName === NO_EXCEPTION) {
                      punch.exceptionName = SET_EMPTY;
                    }
                  }
                  punch.editable = true;
                  if (punch.nonEditable && punch.nonEditable === true) {
                    punch.editable = false;
                  }

                  if (punch.inLocalTS) {
                    let punchInRecordDate = moment(punch.inLocalTS).format(
                      "YYYY-MM-DD"
                    );
                    if (
                      moment(punchInRecordDate).isBefore(previousStartDate) ||
                      moment(punchInRecordDate).isAfter(futureEndDate)
                    ) {
                      punch.editable = false;
                    }
                  }

                  if (!punch.outLocalTS) {
                    punch.outLocalTS = "";
                  }
                  if (!punch.inLocalTS) {
                    punch.inLocalTS = "";
                  }
                  if (punch.isTripEdited){
                    punch.tripEdited = "Yes"
                  }else{
                    punch.tripEdited = "No"
                  }
                });
                reportData.push(...punchesArray);
              }
            }
          }
          //console.log(`-> Report Data -> ${JSON.stringify(reportData)}`);
          resolve(reportData);
        })
        .catch((err) => {
          console.error("in utils > getTransportPunchesData, Err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in utils > getTransportPunchesData, Err===", error);
      reject(error);
    }
  });
};

/**
 * Fn for fetching the worker punch data
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the worker punch records
 */
export const getWorkerPunchRecords = (
  managerId,
  startDate,
  endDate,
  includeWorkers
) => {
  console.log("services > getWorkerPunchRecords called...");
  return new Promise((resolve, reject) => {
    try {
      let workerPunchData = {};
      getWorkersByMgr(managerId)
        .then((data) => {
          if (includeWorkers) {
            let workerDetails = {};
            if (data && data.workers) {
              const workers = data.workers;
              workers.map((item) => {
                workerDetails[item.workerId] = item;
              });
              workerPunchData.workers = workerDetails;
            }
          }
          if (data && data.workerIds && data.workerIds.length > 0) {
            return getWorkerPunches(data.workerIds, startDate, endDate);
          }
        })
        .then((punches) => {
          workerPunchData.punchData = punches;
          //console.log("Dashboard data - ",workerPunchData);
          resolve(workerPunchData);
        })
        .catch((err) => {
          console.error("in services > getWorkerPunchRecords, Err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getWorkerPunchRecords, Err===", error);
      reject(error);
    }
  });
};

/**
 * Fn for fetching the worker punch data
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the worker punch records
 */
export const getWorkerTransportPunchRecords = (
  managerId,
  startDate,
  endDate,
  includeWorkers
) => {
  console.log("services > getWorkerTransportPunchRecords called...");
  return new Promise((resolve, reject) => {
    try {
      let workerPunchData = {};
      getWorkersByMgr(managerId)
        .then((data) => {
          if (includeWorkers) {
            let workerDetails = {};
            if (data && data.workers) {
              const workers = data.workers;
              workers.map((item) => {
                workerDetails[item.workerId] = item;
              });
              workerPunchData.workers = workerDetails;
            }
          }
          if (data && data.workerIds && data.workerIds.length > 0) {
            return getWorkerTransportPunches(data.workerIds, startDate, endDate);
          }
        })
        .then((punches) => {
          workerPunchData.punchData = punches;
          //console.log("Dashboard data - ",workerPunchData);
          resolve(workerPunchData);
        })
        .catch((err) => {
          console.error("in services > getWorkerTransportPunchRecords, Err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getWorkerTransportPunchRecords, Err===", error);
      reject(error);
    }
  });
};

/**
 * Fn for fetching the data for Clocked In tabular report
 * @param {string} - managerId
 * @param {string} - startDate
 * @param {string} - endDate
 * @return: Promise - return the Clocked In dashboard data
 */
export const getClockedInReport = (managerId, startDate, endDate) => {
  console.log("services > getClockedInReport called...");
  return new Promise((resolve, reject) => {
    try {
      let reportData = [];
      let workerDetails = {};
      getWorkerPunchRecords(managerId, startDate, endDate, true)
        .then((punches) => {
          workerDetails = punches.workers;
          punches = punches.punchData;
          if (punches && !isEmptyObject(punches)) {
            let workerIds = Object.keys(punches);
            console.log("Report -> workerIds: ", workerIds);
            if (workerIds.length > 0) {
              for (let i = 0; i < workerIds.length; i++) {
                let punchesArray = punches[workerIds[i]];
                let result = [];
                punchesArray.map((item) => {
                  let keyDate = moment(item.inLocalTS).format(KEY_DATE_FORMAT);
                  if (result.some((e) => e.id === keyDate)) {
                    result.map((obj) => {
                      if (obj.id == keyDate) obj.punches.push(item);
                    });
                  } else {
                    let tempEntry = {};
                    tempEntry.id = keyDate;
                    tempEntry.punches = [];
                    tempEntry.punches.push(item);
                    result.push(tempEntry);
                  }
                });
                result.map((item) => {
                  item = processEntry(item);
                  delete item.punches;
                  if (item.isIncomplete) {
                    item.name =
                      workerDetails[workerIds[i]].firstName +
                      " " +
                      workerDetails[workerIds[i]].lastName +
                      " (" +
                      workerDetails[workerIds[i]].workerId +
                      ")";
                    reportData.push(item);
                  }
                });
              }
            }
          }
          console.log(`-> getClockedInReport -> ${JSON.stringify(reportData)}`);
          resolve(reportData);
        })
        .catch((err) => {
          console.error("in utils > getClockedInReport, Err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in utils > getClockedInReport, Err===", error);
      reject(error);
    }
  });
};

export const ts = (time) => {
  return time
    ? moment(time).format(timeConfig.format4) +
    " " +
    moment(time).format(dateConfig.format5)
    : null;
};

export const time = (time) => {
  return time ? moment(time).format(timeConfig.format3) : null;
};

export const date = (time) => {
  return time ? moment(time).format(dateConfig.format3) : null;
};

/**
 * function to process the incomplete punches entry.
 * This function will:
 * 1. calculate duration open
 * 2. update if the entry is incomplete
 *
 * @param {object} workEntry
 * @returns {object} workEntry
 */
const processEntry = (workEntry) => {
  let isIncomplete = false;
  let jobFamily, activityGroup, activityTS;
  try {
    workEntry.punches.filter((record) => {
      if (
        record.inLocalTS &&
        record.inLocalTS !== "" &&
        (!record.outLocalTS || (record.outLocalTS && record.outLocalTS === ""))
      ) {
        isIncomplete = true;
        jobFamily = record.jobName;
        activityGroup = record.activityGroup;
        activityTS = record.inLocalTS;
        return record;
      }
    });
  } catch (err) {
    console.error("Error in duration calculation: ", err);
  }
  workEntry.isIncomplete = isIncomplete;
  if (isIncomplete && workEntry.punches && workEntry.punches.length > 0) {
    const currentDate = moment(new Date()).format(dateConfig.format4);
    let punch = workEntry.punches[0];
    let startTS;
    if (activityGroup === MEAL) {
      startTS = activityTS;
    } else {
      startTS = punch.inLocalTS;
    }
    let duration = calculateDiffInHrs(startTS, currentDate);
    workEntry.duration = duration.toFixed(2);
    workEntry.startTime = startTS ? startTS : SET_EMPTY;
    workEntry.activity = activityGroup;
    workEntry.jobFamily = jobFamily;
  }
  return workEntry;
};

export const getActivitesByJobFamilyReport = (
  managerId,
  startDate,
  endDate
) => {
  // console.clear();
  console.log(
    "services > getActivitesByJobFamilyReport called................."
  );
  return new Promise((resolve, reject) => {
    try {
      let reportData = [];
      let activityGroupMap = new Map();
      getWorkerPunchRecords(managerId, startDate, endDate, false)
        .then((punches) => {
          punches = punches.punchData;
          if (punches && !isEmptyObject(punches)) {
            const workerIds = Object.keys(punches);
            console.log("Report -> workerIds: ", workerIds);
            if (workerIds.length > 0) {
              for (let i = 0; i < workerIds.length; i++) {
                //console.table(punches[workerIds[i]]);
                const validRecords = createReviewData(punches[workerIds[i]]);
                //console.table(validRecords);
                const activityGroupData = calculateReportData(validRecords);
                const activityGroupList = ACTIVITY_GROUPS2;
                if (activityGroupData && !isEmptyObject(activityGroupData)) {
                  for (let k = 0; k < activityGroupList.length; k++) {
                    const activityGroup = activityGroupList[k];
                    if (activityGroupData[activityGroup]) {
                      let hrs;
                      if (activityGroupMap.get(activityGroup)) {
                        hrs =
                          activityGroupMap.get(activityGroup) +
                          activityGroupData[activityGroup];
                      } else {
                        hrs = activityGroupData[activityGroup];
                      }
                      activityGroupMap.set(activityGroup, hrs);
                    }
                  }
                }
              }
            }
            for (let actGrp of activityGroupMap.keys()) {
              const actGrpHours = activityGroupMap.get(actGrp);
              let actGrpData = {
                name: actGrp,
                value: Math.floor(actGrpHours * 100) / 100,
              };
              reportData.push(actGrpData);
            }
          }
          console.log(
            `Report -> Activity Group Data -> ${JSON.stringify(reportData)}`
          );
          resolve(reportData);
        })
        .catch((err) => {
          console.error(
            "in services > getActivityGroupReportData, Err===",
            err
          );
          reject(err);
        });
    } catch (error) {
      console.error("in services > getActivityGroupReportData, Err===", error);
      reject(error);
    }
  });
};

export const getActivityHoursReportData = (userCountry, startDate) => {
  console.log("services > getActivityHoursReportData called.................");
  return new Promise((resolve, reject) => {
    if (userCountry) {
      try {
        const activityHoursMap = {};
        const employeeHoursMap = {};
        const fromDate = moment(startDate).toISOString();
        collectionRef(IMWAREHOUSEMETRICS_COLLECTION)
          .where("activityEndDateTime", ">=", fromDate)
          .where(COUNTRY, "==", userCountry)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((activity) => {
              const activityData = activity.data();
              const activityStartTime = moment(
                activityData.activityStartDateTime
              );
              const activityEndTime = moment(activityData.activityEndDateTime);

              const employeeNameId =
                properCamelCaseNew(
                  `${activityData.firstName} ${activityData.lastName}`
                ) + `_${activityData.workerId}`;

              const activityName = activityData.activityNameKey;
              const activityHours = moment
                .duration(activityEndTime.diff(activityStartTime))
                .asHours();
              const building =
                activityData.districtId + " " + activityData.buildingId;

              // Planned Activity Hours - Done
              if (activityHoursMap[building] === undefined) {
                activityHoursMap[building] = {};
              }
              if (activityHoursMap[building][activityName] !== undefined) {
                activityHoursMap[building][activityName] += activityHours;
              } else {
                activityHoursMap[building][activityName] = activityHours;
              }

              // Employee Hours by Activity

              if (employeeHoursMap[building] === undefined) {
                employeeHoursMap[building] = {};
              }
              if (employeeHoursMap[building][activityName] === undefined) {
                employeeHoursMap[building][activityName] = {};
              }
              if (
                employeeHoursMap[building][activityName][employeeNameId] !==
                undefined
              ) {
                employeeHoursMap[building][activityName][employeeNameId] +=
                  activityHours;
              } else {
                employeeHoursMap[building][activityName][employeeNameId] =
                  activityHours;
              }
            });
            resolve([activityHoursMap, employeeHoursMap]);
          })
          .catch((error) => {
            console.error(
              "in services > getActivityHoursReportData, Err===",
              error
            );
            reject(error);
          });
      } catch (error) {
        console.error(
          "in services > getActivityHoursReportData, Err===",
          error
        );
        reject(error);
      }
    }
  });
};

export const getWareHouseMetricsReportData = (
  userCountry,
  workerId,
  startDate
) => {
  console.log(
    "services > getActivityHoursReportData called.....:...",
    workerId,
    startDate
  );
  return new Promise(async (resolve, reject) => {
    if (userCountry) {
      try {
        let empData = [];
        const fromDate = moment(startDate)
          .startOf("day")
          .format(dateConfig.format6);
        const endDate = moment(startDate)
          .endOf("day")
          .format(dateConfig.format6);
        await collectionRef(IMWAREHOUSEMETRICS_COLLECTION)
          .where("activityEndDateTime", ">=", fromDate)
          // .where("activityEndDateTime", "<", endDate)
          .where("applicationName", "==", "SKP")
          .where(WORKER_ID, "==", workerId)
          .where("imtDone", "==", true)
          .orderBy("activityEndDateTime")
          .orderBy("activityStartDateTime")
          .get()
          .then(async (querySnapshot) => {
            querySnapshot.forEach((activity) => {
              const activityData = activity.data();

              if (
                moment(activityData.activityEndDateTime).format(
                  dateConfig.format6
                ) == moment(fromDate).format(dateConfig.format6)
              ) {
                // const activityStartTime = moment(
                //   activityData.activityStartDateTime
                // ).toISOString();
                // const activityEndTime = moment(
                //   activityData.activityEndDateTime
                // ).toISOString();
                const activityStartTime = activityData.activityStartDateTime;
                const activityEndTime = activityData.activityEndDateTime;
                activityData.activityStartDateTime = activityStartTime;
                activityData.activityEndDateTime = activityEndTime;
                empData.push({ id: activity.id, ...activityData });
              }
            });
            resolve(empData);
          })
          .catch((error) => {
            console.error(
              "in services > getActivityHoursReportData, Err===",
              error
            );
            reject(error);
          });
      } catch (error) {
        console.error(
          "in services > getActivityHoursReportData, Err===",
          error
        );
        reject(error);
      }
    }
  });
};

export const getDashboardCollection = (managerId, weekNumber) => {
  console.log("services > getDashboardCollection called.................");
  const documentName = weekNumber + "-" + managerId;
  return new Promise((resolve, reject) => {
    try {
      let data = {};
      collectionRef(DASHBOARD_COLLECTION)
        .doc(documentName)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.data()) {
            data = querySnapshot.data();
          }
          resolve(data);
        })
        .catch((error) => {
          console.error("in services > getDashboardCollection, Err===", error);
          reject(error);
        });
    } catch (error) {
      console.error("in services > getDashboardCollection, Err===", error);
      reject(error);
    }
  });
};

export const getDscDashboardCollection = (weekNumber, buildingIds) => {
  console.log(
    "services > getDscDashboardCollection called.................",
    buildingIds
  );

  return new Promise(async (resolve, reject) => {
    try {
      let result = [];
      let buildings = [];
      if (typeof buildingIds === "string") {
        buildings.push(buildingIds);
      } else buildings = buildingIds;
      const dscDashBoardRef = collectionRef(DSC_DASHBOARD_COLLECTION);
      for (let i = 0; i < buildings.length; i++) {
        const buildingId = buildings[i];
        const documentName = weekNumber + "-" + buildingId;
        await dscDashBoardRef
          .doc(documentName)
          .get()
          .then((data) => {
            if (data.exists) {
              result.push({ id: data.id, ...data.data() });
            }
          });
      }
      resolve(result);
    } catch (error) {
      console.error("in services > getDscDashboardCollection, Err===", error);
      reject(error);
    }
  });
};

export const getCapacityPlanningCollection = (weekStartDate, buildingIds) => {
  console.log(
    "services > getCapacityPlanningCollection called.................",
    buildingIds, weekStartDate
  );
  return new Promise(async (resolve, reject) => {
    try {
      let result = [];
      let buildings = [];
      if (typeof buildingIds === "string") {
        buildings.push(buildingIds);
      } else buildings = buildingIds;
      const capacityPlanningRef = collectionRef(CAPACITY_PLANNING);
      for (let i = 0; i < buildings.length; i++) {
        const buildingId = buildings[i];
        // const documentName = weekNumber + "-" + buildingId;
        await capacityPlanningRef
        //.where(DISTRICT_ID, "==", districtId)
        .where(PRIMARY_BUILDING, "==", buildingId)
        .where(START_DATE, "==", weekStartDate)
          .get()
          .then((snapshot) => {
            if (snapshot.size > 0 ) {
              let docData = snapshot.docs[0].data()
              result.push({ id: snapshot.docs[0].id, ...docData });
            }
          });
      }
      resolve(result);
    } catch (error) {
      console.error("in services > getCapacityPlanningCollection, Err===", error);
      reject(error);
    }
  });
};

export const getSelectedBuildingTargetAph = (districtName, buildingIds) => {
  console.log(
    "services > getSelectedBuildingTargetAph called.................",
    buildingIds
  );

  return new Promise(async (resolve, reject) => {
    try {
      let result = [];
      let buildings = [];
      if (typeof buildingIds === "string") {
        buildings.push(buildingIds);
      } else buildings = buildingIds;
      for (let i = 0; i < buildings.length; i++) {
        const buildingId = buildings[i];
        await collectionRef(LOCATIONS_COLLECTION)
          .doc(districtName)
          .collection('buildings')
          .doc(buildingId)
          .collection("dscActivities")
          .doc(buildingId)
          .get()
          .then((data) => {
            if (data.exists) {
              result.push({ id: data.id, ...data.data() });
            }
          });
      }
      resolve(result);
    } catch (error) {
      console.error("in services > getSelectedBuildingTargetAph, Err===", error);
      reject(error);
    }
  });
};

